import {StyleSheet} from 'react-native';
import font from '@buncha/appStyles/style/font';

export const styles = StyleSheet.create({
  titleTypo: {
    ...font.FontSize.fontH5,
  },
});
